<div #chartContainer>
    <ui-figure-caption>
        <ui-figure-text>
            <h4>Andel av tallstammarna i ungskog som årligen skadas av vilt inklusive felmarginal</h4>
        </ui-figure-text>
    </ui-figure-caption>
    <br />
    <app-google-combochart [data]="data" [options]="options" [chartName]="chartName"></app-google-combochart>
    <ui-error-margin />
</div>
